import {
  getAccessToken,
} from '@/app/common/utils/customFetchBase';

/**
 * استخراج UUID کاربر از پاسخ /api/user/info یا از JWT دسترسی.
 */
export function resolvePanelUserId(
  userInfo: { data?: Record<string, unknown> } | null | undefined,
): string | null {
  const data = userInfo?.data;
  if (data) {
    for (const key of ['id', 'uuid', 'user_id', 'userId'] as const) {
      const value = data[key];
      if (typeof value === 'string' && isUuid(value)) return value;
    }
  }

  try {
    const token = getAccessToken();
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1] ?? '')) as Record<
      string,
      unknown
    >;
    for (const key of ['sub', 'id', 'user_id', 'userId'] as const) {
      const value = payload[key];
      if (typeof value === 'string' && isUuid(value)) return value;
    }
  } catch {
    /* ignore */
  }
  return null;
}

function isUuid(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
    value.trim(),
  );
}

/** ساخت siteUrl از نام دامنه DomainSelector */
export function siteUrlFromDomainName(
  name: string | null | undefined,
): string | undefined {
  if (!name || name === 'no-domain') return undefined;
  if (/^https?:\/\//i.test(name)) return name;
  return `https://${name.replace(/\/$/, '')}/`;
}
